import ForwardSlashIcon from "./ForwardSlashIcon";
export default ForwardSlashIcon;
